module.exports = __webpack_public_path__ + "harp.jpg?961ec12cb20f6368042b14096eb6d8e7";